import BaseClass from '../../libs/base/BaseClass';

/**
 * マップ埋め込み制御
 */
export default class MapEmbedClass extends BaseClass {
  constructor(_target) {
    super();
    this.name = 'MapEmbedClass';
    this.target = _target;

    this.isMapReady = false;
    this.isEmbed = false;

    this.nowPos = {
      lat: null,
      lng: null,
    };
  }

  onCreate() {

    this.isDisableDefaultUI = (this.target.attr('data-type'));

    // data属性の監視
    const observer = new MutationObserver((e) => {
      // console.log(this.name,e,this.target);
      if (this.isMapReady) { this.mapEmbed(); }
    });
    observer.observe(this.target.get(0), { attributes: true });
  }

  mapReady() {
    this.isMapReady = true;
    this.mapEmbed();
  }

  mapEmbed() {
    if (!this.target.attr('data-lat') || !this.target.attr('data-lng')) { return; }
    const position = { lat: parseFloat(this.target.attr('data-lat')), lng: parseFloat(this.target.attr('data-lng')) };
    if (this.nowPos.lat === position.lat && this.nowPos.lng === position.lng) { return; }
    const map = new google.maps.Map(this.target.get(0), { zoom: 16, center: position, disableDefaultUI: this.isDisableDefaultUI });
    const marker = new google.maps.Marker({ position: position, map: map });
    this.nowPos = position;
  }
}
